import Y1 from "./d_channels_Y1";
import Y2 from "./d_channels_Y2";
import Y3 from "./d_channels_Y3";

const channels = {Y1, Y2, Y3}


export default channels;